<template>
    <v-container class='pa-0'>
        <h3 class=" pb-3">Add a Folder</h3>
        <hr class="thick" />
        <div class=' mb-4 mt-3'>
            <v-form ref="newFolderForm" v-model="form.valid">
                <div class="width-50">
                    <v-text-field v-model="directoryName"  label="Folder Name*" :rules="form.directoryName" class='mb-0'></v-text-field>
                    <!-- This input is a crumby work around for what appears to be a bug in Vue. -->
                    <!-- see https://forum.framework7.io/t/vue-pressing-enter-key-in-input-causes-app-to-reload/2585/10 -->
                    <input type="text" style="display: none" />
                    <div v-if="error">
                        <span class="msg error">{{ error }}</span>
                    </div>
                </div>
                <div class="mt-4">
                    <v-btn class='ml-0' v-bind:disabled="!submitActive" v-on:click="addFolder" color="primary">Add Folder</v-btn>
                    <v-btn v-on:click="hideModal">Cancel and Close</v-btn>
                </div>
            </v-form>
        </div>
    </v-container>
</template>

<script>
import modal from './../mixins/modal';
import translate from './../../../mixins/translate';

export default {
  name: 'NewFolder',
  mixins: [modal, translate],
  data() {
    return {
      // name for new directory
      directoryName: '',
      openDialog: true,
      // directory exist
      directoryExist: false,
      error: null,
      form: {
        valid: false,
        directoryName: [v => !!v || 'Please enter a folder name'],
      },
    };
  },
  computed: {
    /**
             * Submit button - active or no
             * @returns {string|boolean}
             */
    submitActive() {
      return this.directoryName && !this.directoryExist;
    },
  },
  methods: {
    closeDialog() {
      this.openDialog = false;
    },
    /**
             * Check the folder name if it exists or not.
             */
    validateDirName() {
      if (this.directoryName) {
        this.directoryExist = this.$store.getters[`fm/${this.activeManager}/directoryExist`](this.directoryName);
      } else {
        this.directoryExist = false;
      }
    },

    /**
             * Create new directory
             */
    addFolder() {
      this.error = null;
      const that = this;
      this.$store.dispatch('fm/createDirectory', this.directoryName).then((response) => {
        // if new directory created successfully
        if (response.data.result.status === 'success') {
          // close modal window
          this.hideModal();
        } else {
          that.error = response.data.result.message;
        }
      });
    },
  },
};
</script>
